<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input v-model.trim="searchForm.contractNum" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入合同编号" @blur="salaryChange" />
      </el-form-item>
      <el-form-item label="销售人员:" prop="createByName">
        <el-input v-model.trim="searchForm.createByName" placeholder="请输入销售人员姓名" />
      </el-form-item>
      <el-form-item label="合同时间:" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>

      <el-form-item label="订单分类:" prop="contractType">
        <el-select v-model="searchForm.contractType" placeholder="请选择" clearable>
          <el-option v-for="option in orderType" :key="option.code" :label="option.name" :value="option.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="最终客户:" prop="clientName">
        <el-input v-model.trim="searchForm.clientName" placeholder="请输入最终客户名称" />
      </el-form-item>
      <el-form-item label="供货单位:" prop="supplyUnit">
        <el-select v-model="searchForm.supplyUnit" placeholder="请选择供货单位" clearable>
          <el-option v-for="option in supplyUnit" :key="option.code" :label="option.name" :value="option.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="云享DC/战略:" prop="specialProduct">
        <el-select v-model="searchForm.specialProduct" placeholder="请选择云享DC/战略" clearable>
          <el-option
            v-for="item in specialProductList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div class="operate-btn-wrap">
      <el-button type="primary" :loading="submitLoading" @click="exportAllNotDelivered">
        导出欠货报表
      </el-button>
      <el-button type="default" :loading="submitLoading" @click="exportAgentOrderInfo">
        导出订单明细
      </el-button>
      <el-button type="default" :loading="submitLoading" @click="exportAllocationDetailRecord">
        导出分配明细
      </el-button>
      <el-button v-if="$store.state.user.userId=='SM0001'" type="default" @click="importGoodsMessage">
        导入发货信息
      </el-button>
    </div>

    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
        <el-table-column prop="projectName" label="项目名称" align="left" min-width="170" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" class="el-btn-text-left" @click="$router.push({name:'ContractInfo',params:{contractNum:row.contractNum},query: { id: row.id, masterProjectName: row.projectName,isSon:row.isSon,distributeFlag: true }})">
              {{ row.projectName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="contractNum" label="合同编号" align="left" width="150" />
        <el-table-column prop="contractType" label="订单分类" align="left" width="130">
          <template v-slot="{row}">
            <span v-if="row.freightContract">{{ row.contractType +'(价外费用)' }}</span>
            <span v-else>{{ row.contractType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractSum" label="订单金额" align="right" width="130" header-align="left">
          <template v-slot="{row}">
            {{ Number(row.contractSum).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="salesManName" label="销售人员" align="left" width="130" />
        <el-table-column prop="createTime" label="合同时间" align="left" width="140" />
        <el-table-column prop="createTime" label="合同状态" align="left" width="150">
          <template v-slot="{row}">
            <span v-if="row.isSon === false">
              <span v-if="row.isDelete">
                已废弃
              </span>
              <span v-else>
                {{ row.statusValue }}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="是否废弃" align="left" width="70">
          <template v-slot="{row}">
            <span v-if="row.isDelete">
              是
            </span>
            <span v-else>
              否
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="合同附件" align="left" width="80" fixed="right">
          <template v-slot="{row}">
            <el-button v-if="row.statusValue!=='待提交' && row.isSon === false" slot="reference" type="text" @click="showAttachment(row.id)">
              合同附件
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="订单跟踪" align="left" width="70" fixed="right">
          <template v-slot="{row, $index}">
            <el-popover
              v-if="row.isSon === false"
              placement="left"
              width="400"
              trigger="click"
              @show="togglePopover(row, true, `orderFlow-${$index}`)"
              @hide="togglePopover(row, false)"
            >
              <order-flow v-if="row.isShowPopover" :ref="`orderFlow-${$index}`" :contract-id="row.contractNum" style="max-height: 300px;min-height: 0;overflow-y: auto" />
              <el-button slot="reference" type="text">
                查看
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" width="150" align="left" fixed="right">
          <template v-slot="{row}">
            <!-- <el-button type="text" @click="changeGooods(row)" v-if="row.changeDeliveryDate === true">
              变更要货日期
            </el-button> -->
            <el-button v-if="row.contractProcessStatus==1 && !row.isDelete&&!row.isSon" type="text" @click="doAction(row)">
              办理
            </el-button>
            <el-button v-if="row.statusValue=='待盖章' && !row.isDelete&&!row.isSon" type="text" @click="doAction(row)">
              盖章
            </el-button>
            <el-button v-if="row.contractStatus==2 && !row.isSon && Number(row.contractSum) !== 0" type="text" @click="openDeliverGoods(row)">
              申请分批发货
            </el-button>
            <template v-if="row.statusValue&&!row.isDelete&&row.statusValue.indexOf('待付款')!=-1">
              <el-button type="text" @click="doAction(row)">
                付款
              </el-button>
              <el-button v-if="row.contractStatus===1" slot="reference" type="text" style="color: #F56C6C;margin-left: 10px;" @click="handleRecall(row)">
                召回合同
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="合同附件" :visible.sync="contractVisible" width="800px">
      <contract-attachment v-if="contractVisible" :contract-num="contractNum" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="contractVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <a ref="downTag" :href="exportUrl" target="_blank" />
    <importGoodsMessage :dialog-form-visible="dialogFormVisibleImport" @on-status-dialog="updataDialogFormVisibleImport" />

    <changeGoods :id="goodsRow" :dialog-form-visible="dialogFormVisible" @on-status-dialog="updataDialogFormVisible" />
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import changeGoods from './common/changeGoods';
import { selectContractInfoList, cancelContract, exportAllNotDelivered, exportAgentOrderInfo, exportAllocationDetailRecord } from '@/API';
import orderFlow from './common/orderFlow';
import importGoodsMessage from './importGoodsMessage.vue';
import contractAttachment from './contractAttachment';

export default {
  data () {
    return {
      searchForm: {
        projectName: '',
        contractNum: '',
        contractProcessStatus: 0,
        createByName: '',
        contractType: '',
        clientName: '',
        supplyUnit: '',
        createBeginTime: '',
        createEndTime: '',
        specialProduct: ''
      },
      goodsRow: {},
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibleImport: false,
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      specialProductList: [{
        name: '云享',
        code: 1
      }, { name: '战略',
        code: 2 }, { name: '全部',
        code: 0 }],
      contractVisible: false,
      contractNum: '',
      exportUrl: '',
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            let date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      submitLoading: false
    };
  },
  components: {
    orderFlow,
    contractAttachment,
    changeGoods,
    importGoodsMessage
  },
  computed: {
    ...mapState({
      orderType: state => state.enumeration.orderType,
      contracStatus: state => state.enumeration.contracStatus,
      supplyUnit: state => state.enumeration.supplyUnit
    })
  },
  methods: {
    // blur
    salaryChange (e) {
      this.searchForm.contractNum = (e.target.value || '').trim();
    },
    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    importGoodsMessage () {
      this.dialogFormVisibleImport = true;
    },
    // 组件事件
    updataDialogFormVisibleImport (val) {
      this.dialogFormVisibleImport = val;
    },
    doSearch () {
      this.tableLoading = true;
      selectContractInfoList({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.currentPage = json.data.pageNum;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    // 变更要货按钮
    changeGooods (row) {
      this.dialogFormVisible = true;
      this.goodsRow = row;
    },
    doAction (row) {
      if (row.contractProcessStatus === 1) {
        this.$router.push({
          name: 'Submission',
          params: {
            contractNum: row.contractNum
          }
        });
      } else if (row.contractProcessStatus === 2) {
        this.$router.push({
          name: 'doSeal',
          params: {
            contractNum: row.id
          }
        });
      } else if (row.contractProcessStatus === 3) {
        this.$router.push({
          name: 'distribution',
          params: {
            contractNum: row.contractNum
          }
        });
      }
    },
    handleRecall (row) {
      this.$confirm('是否召回此合同?', '', {
        confirmButtonText: '召回',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cancelContractRecall(row);
      }).catch((e) => {
        console.log(e);
      });
    },
    cancelContractRecall (row) {
      // 代理商取消合同
      this.tableLoading = true;
      cancelContract(row.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('召回成功');
          this.doSearch();
        } else {
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 查看合同附件弹出框
    showAttachment (val) {
      this.contractNum = val;
      this.contractVisible = true;
    },
    exportAllocationDetailRecord () {
      this.submitLoading = true;
      exportAllocationDetailRecord(this.searchForm.createBeginTime, this.searchForm.createEndTime, this.searchForm.projectName, this.searchForm.contractNum).then((res) => {
        this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '分配明细' + new Date().toLocaleString() + '.xlsx';
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    },
    exportAgentOrderInfo () {
      if (!this.searchForm.createBeginTime || !this.searchForm.createEndTime) {
        this.$message.error('请输入合同时间');
        return;
      }
      // this.exportUrl = `${API.defaults.baseURL}/export/exportAgentOrderInfo?createBeginTime=${this.searchForm.createBeginTime}&createEndTime=${this.searchForm.createEndTime}`;
      // this.$nextTick(() => {
      //   this.$refs.downTag.click();
      // });
      exportAgentOrderInfo(this.searchForm.createBeginTime, this.searchForm.createEndTime).then((res) => {
        console.log(res);
        this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '订单明细' + new Date().toLocaleString() + '.xlsx';
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {});
    },
    exportAllNotDelivered () {
      this.submitLoading = true;
      exportAllNotDelivered().then((res) => {
        this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '欠货报表' + new Date().toLocaleString() + '.xlsx';
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {});
    },
    openDeliverGoods (row) {
      const routeUrl = this.$router.resolve({
        name: 'ContractInfo',
        params: { contractNum: row.contractNum },
        query: {
          id: row.id,
          masterProjectName: row.projectName,
          transact: '1',
          distributeContractTypeFlag: row.distributeContractTypeFlag ?? false
        }
      });
      window.open(routeUrl.href, '_blank');
    },

    togglePopover (row, isTrue, ref) {
      this.$set(row, 'isShowPopover', isTrue);
      this.$nextTick(() => {
        this.$refs[ref] && this.$refs[ref].initData();
      });
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
